<template>
  <div class="bang-phi-vung">
    <h3 class="text-center" style="background: none;">
      <a href="https://drive.google.com/file/d/1CpLVmDzLnyY4b7GGkx1b4ri6D5zoV4qz/view?usp=sharing"
        style="font-weight: 600;" target="_blank">
      Phí dịch vụ giao dịch thông minh ngày 04/03/2026
      </a>
    </h3>
    <table>
      <thead>
        <tr>
          <th>STT</th>
          <th>Giao dịch thông minh</th>
          <th>Mức phí</th>
          <th>Phí tối thiểu</th>
        </tr>
      </thead>
      <tbody>
        <!-- I. THANH TOÁN -->
        <tr>
          <td colspan="4" style="background:#f1f5f9; font-weight:bold; text-align: start;">I. THANH TOÁN</td>
        </tr>
        <tr>
          <td colspan="4" class="text-start" style="background: #e7e7e7;"> Ví điện tử của Vimass gồm ví điện thoại, ví dạng thẻ (thẻ sinh trắc
            học hoặc thẻ đa năng) và ví doanh nghiệp</td>
        </tr>
        <tr>
          <td>1</td>
          <td>Chuyển tiền từ ví đến ví</td>
          <td class="text-center">0.01%</td>
          <td class="text-center">250 đồng</td>
        </tr>
        <tr>
          <td>2</td>
          <td>Chuyển tiền từ ví đến tài khoản hoặc thẻ ngân hàng</td>
          <td class="text-center">0.03%</td>
          <td class="text-center">750 đồng</td>
        </tr>
        <tr>
          <td>3</td>
          <td>Quét VNPAY QR</td>
          <td class="text-center">0.03%</td>
          <td class="text-center">750 đồng</td>
        </tr>
        <tr>
          <td>4</td>
          <td>Nạp tiền vào ví</td>
          <td class="text-center">Miễn phí</td>
          <td></td>
        </tr>
        <tr>
          <td colspan="4" class="text-start" style="background: #e7e7e7;">Thanh toán tại cửa hàng được tạo bởi ứng dụng Vimass</td>
        </tr>
        <tr>
          <td>5</td>
          <td>Thanh toán bằng ví điện thoại hoặc ví doanh nghiệp</td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td></td>
          <td>Bên nhận thanh toán</td>
          <td class="text-center">0.01%</td>
          <td class="text-center">250 đồng</td>
        </tr>
        <tr>
          <td></td>
          <td>Bên thanh toán</td>
          <td class="text-center">0.01%</td>
          <td class="text-center">250 đồng</td>
        </tr>
        <tr>
          <td>6</td>
          <td>Thanh toán bằng ví dạng thẻ (thẻ sinh trắc học hoặc thẻ đa năng)</td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td></td>
          <td>Bên nhận thanh toán</td>
          <td class="text-center">0.02%</td>
          <td class="text-center">500 đồng</td>
        </tr>
        <tr>
          <td></td>
          <td>Bên thanh toán</td>
          <td class="text-center">Miễn phí</td>
          <td></td>
        </tr>
        <tr>
          <td>7</td>
          <td>Nhận tiền qua QR âm thanh từ ứng dụng ngân hàng</td>
          <td class="text-center">0.02%</td>
          <td class="text-center">500 đồng</td>
        </tr>
        <!-- III. Thu chi hộ qua API -->
        <tr>
          <td colspan="4" class="text-start"  style="background: #e7e7e7;"><a href="https://vimass.vn/vi/chi-tiet.html/1719997599950aUoQY" target="_blank">Chi hộ qua API</a></td>
        </tr>
        <tr>
          <td>8</td>
          <td><a target="_blank" href="https://docs.google.com/document/d/1FuZOD086Qo9rKjvd9taTOzJsMtS3tNcp/edit"> Hợp đồng thu chi hộ qua API phí cố định </a></td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td></td>
          <td>Chi hộ</td>
          <td class="text-center">2.700 đồng</td>
          <td></td>
        </tr>
        <tr>
          <td></td>
          <td>Thu hộ</td>
          <td class="text-center">2.000 đồng</td>
          <td></td>
        </tr>
        <tr>
          <td>9</td>
          <td> <a target="_blank" href="https://docs.google.com/document/d/1lf3a4QIVpJNP11A1kb9SloeJKTCqEhMx/edit"> Hợp đồng thu chi hộ qua API phí thay đổi </a></td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td></td>
          <td>Chi hộ: </td>
          <td class="text-center"></td>
          <td class="text-center"></td>
        </tr>
          <tr>
          <td></td>
          <td>Từ GD 1 đến GD 300.000 </td>
          <td class="text-center">0.03%</td>
          <td class="text-center">2.500 đồng</td>
        </tr>
          <tr>
          <td></td>
          <td>Từ GD 300.001 đến GD 500.000  </td>
          <td class="text-center">0.03%</td>
          <td class="text-center">2.300 đồng</td>
        </tr>
         <tr>
          <td></td>
          <td>Từ GD 500.001 đến GD 750.000  </td>
          <td class="text-center">0.03%</td>
          <td class="text-center">2.100 đồng</td>
        </tr>
        <tr>
          <td></td>
          <td>Từ GD 750.001  </td>
          <td class="text-center">0.03%</td>
          <td class="text-center">1.900 đồng</td>
        </tr>
        <tr>
          <td></td>
          <td>Thu hộ</td>
          <td class="text-center">0.03%</td>
          <td class="text-center">1.800 đồng</td>
        </tr>
        <!-- Dịch vụ QR khác -->
        <tr>
          <td colspan="4" class="text-start" style="background: #e7e7e7;">Phí thu hộ qua QR tài khoản trung gian</td>
        </tr>
        <tr>
          <td>10</td>
          <td>Phí thu hộ, báo có, chuyển tiền từ tài khoản trung gian về tài khoản ngân hàng của bên nhận thanh toán</td>
          <td class="text-center"></td>
          <td class="text-center"></td>
        </tr>
        <tr>
          <td></td>
          <td>Chuyển ngay khi bên thanh toán sử dụng ứng dụng ngân hàng, ví điện tử khác</td>
          <td class="text-center">0,02%</td>
          <td>500 đồng</td>
        </tr>
           <tr>
          <td></td>
          <td>Chuyển ngay khi bên thanh toán sử dụng ví Vimass</td>
          <td class="text-center">0,01%</td>
          <td>250 đồng</td>
        </tr>

           <tr>
          <td></td>
          <td>Chuyển theo phiên 2 lần/ngày (vào 07:00 và 13:00)</td>
          <td class="text-center">0,02%</td>
          <td>250 đồng</td>
        </tr>
           <tr>
          <td></td>
          <td>Chuyển theo phiên 4 lần/ngày (vào 06:00, 10:00, 13:00 và 16:00)</td>
          <td class="text-center">0,02%</td>
          <td>300 đồng</td>
        </tr> 
          <!-- <tr>
          <td></td>
          <td>Chuyển theo phiên 6 lần/ngày (vào 00:00, 04:00, 08:00, 12:00, 16:00, 20:00)</td>
          <td class="text-center">0,02%</td>
          <td>400 đồng</td>
        </tr>  -->
        <tr>
          <td>11</td>
          <td>Phí thu hộ về ví Vimass (gồm ví điện thoại, thẻ chip, thẻ A, thẻ B, ví doanh nghiệp)</td>
          <td class="text-center">0,01%</td>
          <td>250 đồng</td>
        </tr>
         <tr>
          <td>12</td>
          <td>Phí hóa đơn</td>
          <td class="text-center"></td>
          <td></td>
        </tr>
         <tr>
          <td></td>
          <td>Yêu cầu hóa đơn</td>
          <td class="text-center">0,01%</td>
          <td>250 đồng</td>
        </tr>
         <tr>
          <td></td>
          <td>Phát hành hóa đơn</td>
          <td class="text-center">0,01%</td>
          <td>250 đồng</td>
        </tr>
        <!-- II. GIÁO DỤC -->
        <tr>
          <td colspan="4" class="text-start" style="background:#f1f5f9; font-weight:bold;">II. GIÁO DỤC</td>
        </tr>
        <tr>
          <td colspan="4" class="text-start" style="background: #e7e7e7;">Dịch vụ lưu trữ trên máy chủ Vimass (VCloud)</td>
        </tr>
        <tr>
          <td>13</td>
          <td>Gói lưu trữ 50GB sử dụng trong 1 năm</td>
          <td class="text-center">112.500 đồng</td>
          <td></td>
        </tr>
        <tr>
          <td>14</td>
          <td>Gói lưu trữ 100GB sử dụng trong 1 năm</td>
          <td class="text-center">225.000 đồng</td>
          <td></td>
        </tr>
        <tr>
          <td>15</td>
          <td>Gói lưu trữ 2TB sử dụng trong 1 năm</td>
          <td class="text-center">1.125.000 đồng</td>
          <td></td>
        </tr>
         <tr>
          <td colspan="4" class="text-start" style="background: #e7e7e7;">Dịch vụ sử dụng trí tuệ nhân tạo qua API có trả phí</td>
        </tr>
        <tr>
          <td>16</td>
          <td>Phí cộng thêm khi dùng API của nhà cung cấp trí tuệ nhân tạo </td>
          <td class="text-center">10%</td>
          <td>250 đồng</td>
        </tr>
        <!-- III. GIAO THÔNG -->
        <tr>
          <td colspan="4" class="text-start" style="background:#f1f5f9; font-weight:bold;">III. GIAO THÔNG</td>
        </tr>
        <tr>
          <td>17</td>
          <td>Dịch vụ thông minh trông giữ xe máy</td>
          <td class="text-center">0.02%</td>
          <td class="text-center">500 đồng</td>
        </tr>
        <tr>
          <td>18</td>
          <td>Dịch vụ thông minh trông giữ xe ô tô</td>
          <td class="text-center">0.02%</td>
          <td class="text-center">2.000 đồng</td>
        </tr>
        <tr>
          <td>19</td>
          <td>Dịch vụ phạt nguội vi phạm giao thông</td>
          <td class="text-center">0.02%</td>
          <td class="text-center">2.000 đồng</td>
        </tr>
        <!-- IV. Y TẾ -->
        <tr>
          <td colspan="4" class="text-start" style="background:#f1f5f9; font-weight:bold;">IV. Y TẾ</td>
        </tr>
        <tr>
          <td>20</td>
          <td>Dịch vụ y tế</td>
          <td class="text-center">0.01%</td>
          <td class="text-center">250 đồng</td>
        </tr>
        <!-- V. DỊCH VỤ CÔNG -->
        <tr>
          <td colspan="4" class="text-start" style="background:#f1f5f9; font-weight:bold;">V. DỊCH VỤ CÔNG</td>
        </tr>
        <tr>
          <td>21</td>
          <td>Dịch vụ công</td>
             <td class="text-center">0.01%</td>
          <td class="text-center">250 đồng</td>
        </tr>
        <!-- VI. NÔNG NGHIỆP -->
        <tr>
          <td colspan="4" class="text-start" style="background:#f1f5f9; font-weight:bold;">VI. NÔNG NGHIỆP</td>
        </tr>
        <tr>
          <td>22</td>
            <td>Dịch vụ nông nghiệp</td>
            <td class="text-center">0.01%</td>
          <td class="text-center">250 đồng</td>
        </tr>
        <!-- VII. TRÍNH BIÊN TẬP AI -->
        <tr>
          <td colspan="4" class="text-start" style="background:#f1f5f9; font-weight:bold;">VII. TRÍNH BIÊN TẬP AI</td>
        </tr>
        <tr>
          <td>23</td>
          <td>Phí biên tập 1 link trên ai.vimass.vn, lưu giữ và chỉnh sửa trong 10 năm</td>
          <td class="text-center">0.03%</td>
          <td class="text-center">750 đồng</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<style scoped>
.bang-phi-vung {
  font-family: Arial, sans-serif;
  padding: 20px;
  max-width: 100%;
  margin: auto;
}

h3 {
  background-color: #e2e8f0;
  padding: 10px;
  font-size: 14px !important;
  color: #2d3748;
  margin-bottom: 0px;
}

table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  background: #fff;
}

th,
td {
  border: 1px solid #cbd5e0;
  padding: 8px 12px;
  font-size: 14px;
  box-sizing: border-box;
  text-align: start;
}

th {
  background-color: #3badfa;
  font-weight: bold;
  text-align: center;
}

td {
  vertical-align: top;
}

/* Chia cụ thể chiều rộng từng cột */
th:nth-child(1),
td:nth-child(1) {
  width: 6%;
  /* STT */
  text-align: center;
}

th:nth-child(2),
td:nth-child(2) {
  width: 48%;
  /* Dịch vụ */
}

th:nth-child(3),
td:nth-child(3) {
  width: 23%;
  /* Mức phí */
  text-align: center;
}

th:nth-child(4),
td:nth-child(4) {
  width: 23%;
  /* Phí tối thiểu */
  text-align: center;
}

tr:nth-child(even) {
  background-color: #f9f9f9;
}
</style>